export default __webpack_public_path__ + "static/media/mojito.b452fffc.jpg";